module.exports = __webpack_public_path__ + "static/yeshu-mil-gaya-1e3b58016ec38d2b38dd04a5c34331a2.png";